import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  compareValues,
  SortDirection,
  toggleSortDirection,
} from '../../../lib/utils/sort';
import {
  ExamEventService,
  ExamService,
} from '../../../services';
import {
  ExamCenter,
  ExamEvent,
  SelectOption,
} from '../../../types';

type SortColumn = 'testeventTime' | 'testId';

@Component({
  selector: 'app-exam-event-table',
  templateUrl: './exam-event-table.component.html',
  styleUrls: ['./exam-event-table.component.scss'],
})
export class ExamEventTableComponent implements OnInit {
  @Input() examCenter!: ExamCenter;
  @Output() itemClicked = new EventEmitter<ExamEvent>();
  @Output() createClicked = new EventEmitter<void>();

  rowsConfig: SortColumn[] = ['testeventTime', 'testId'];
  sortColumn: SortColumn = 'testeventTime';
  sortDirection: SortDirection = 'asc';

  constructor(
    private examEventService: ExamEventService,
    private examService: ExamService
  ) {}

  ngOnInit(): void {
    this.examEventService.listState.filter =
      ExamEventService.resetFilter();
    this.examEventService.listState.filter.testcentersId =
      this.examCenter.id;
    this.examEventService.loadList();
  }

  get items(): ExamEvent[] {
    const sorted = [
      ...this.examEventService.listState.response.items,
    ];
    return sorted.sort((a, b) => {
      const valA = this.getSortValue(a);
      const valB = this.getSortValue(b);
      return compareValues(valA, valB, this.sortDirection);
    });
  }

  getSortValue(item: ExamEvent): any {
    switch (this.sortColumn) {
      case 'testeventTime':
        return item.testeventTime;
      case 'testId':
        return this.getTestName(item)?.toLowerCase() || '';
      default:
        return '';
    }
  }

  sortBy(column: SortColumn): void {
    const next = toggleSortDirection(
      this.sortColumn,
      column,
      this.sortDirection
    );
    this.sortColumn = next.column;
    this.sortDirection = next.direction;
  }

  getTestName(examEvent: ExamEvent): string {
    const examOption =
      this.examService.examSelectOptions.find(
        (item) => item.value === examEvent.testId
      );
    return (examOption as SelectOption)?.label;
  }

  getTestLogo(examEvent: ExamEvent): string | undefined {
    const examOption =
      this.examService.examSelectOptions.find(
        (item) => item.value === examEvent.testId
      );
    return (examOption as SelectOption)?.imagePath;
  }

  rowClicked(examEvent: ExamEvent): void {
    this.itemClicked.emit(examEvent);
  }

  createButtonClicked(): void {
    this.createClicked.emit();
  }
}
